// extracted by mini-css-extract-plugin
module.exports = {"w-full":"errorBlock_w-full__18A4s","wFull":"errorBlock_w-full__18A4s","w-half":"errorBlock_w-half__2c3pj","wHalf":"errorBlock_w-half__2c3pj","w-150":"errorBlock_w-150__YJUb5","w150":"errorBlock_w-150__YJUb5","w-0":"errorBlock_w-0__1xYJ4","w0":"errorBlock_w-0__1xYJ4","h-full":"errorBlock_h-full__1pIkO","hFull":"errorBlock_h-full__1pIkO","container":"errorBlock_container__M-M7x"};
    if(module.hot) {
      // 1790670234712
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  